import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { SITE_URL, resolveMeta, DEFAULT_IMAGE } from "@/seo/routeMeta";

const RouteSEO = () => {
  const { pathname } = useLocation();
  const meta = resolveMeta(pathname);
  const url = `${SITE_URL}${pathname === "/" ? "/" : pathname}`;
  const image = `${SITE_URL}${meta.image ?? DEFAULT_IMAGE}`;
  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={meta.type ?? "website"} />
      <meta property="og:image" content={image} />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default RouteSEO;
